import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { DeschideHero } from '../components/deschide/DeschideHero';
import { DeschideProblem } from '../components/deschide/DeschideProblem';
import { DeschideCurriculum } from '../components/deschide/DeschideCurriculum';
import { DeschideBenefits } from '../components/deschide/DeschideBenefits';
import { DeschideAbout } from '../components/deschide/DeschideAbout';
import { DeschideForWho } from '../components/deschide/DeschideForWho';
import { DeschidePricing } from '../components/deschide/DeschidePricing';
import { DeschideTestimonials } from '../components/deschide/DeschideTestimonials';
import { DeschideFAQ } from '../components/deschide/DeschideFAQ';
export function DeschidePage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2340">
      <Header data-id="element-2341" />
      <main data-id="element-2342">
        <DeschideHero data-id="element-2343" />
        <DeschideProblem data-id="element-2344" />
        <DeschideCurriculum data-id="element-2345" />
        <DeschideBenefits data-id="element-2346" />
        <DeschideAbout data-id="element-2347" />
        <DeschideForWho data-id="element-2348" />
        <DeschidePricing data-id="element-2349" />
        <DeschideTestimonials data-id="element-2350" />
        <DeschideFAQ data-id="element-2351" />
      </main>
      <Footer data-id="element-2352" />
    </div>;
}